module.exports = __webpack_public_path__ + "static/media/bg_row_big.ec54f2a9.png";